export default __webpack_public_path__ + "static/media/20210205_170209.a4aff6fa.jpg";